import React from "react";
import './Footer.css';


const Footer = () => {

    return(
        <>
        <footer className="w-75 mx-auto text-center p-2 mt-5" id="footer">
            Created By 
            <a href="https://github.com/DevBasito"> DevBasito. </a>
            Challenge By <a href="https://frontendmentor.io"> Frontend Mentor.</a>
        </footer>
        </>
    )
}

export default Footer;